module.exports = __webpack_public_path__ + "img/npublicaciones.c972088f.svg";